module.exports = __webpack_public_path__ + "img/banner-img-2.10964ffe.png";